import { render, staticRenderFns } from "./DescriptionAndDefects.vue?vue&type=template&id=d55e3edc&scoped=true"
import script from "./DescriptionAndDefects.vue?vue&type=script&lang=js"
export * from "./DescriptionAndDefects.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAndDefects.vue?vue&type=style&index=0&id=d55e3edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55e3edc",
  null
  
)

export default component.exports